export enum IntermediaryFeePeriodEnum {
  MONTHLY = 'Per month',
  QUARTER = 'Per quarter',
  HALF_YEAR = 'Per half year',
  YEAR = 'Per year',
  ONE_TIME = 'One time',
}

export enum IntermediarySubscriptionFeePeriodEnum {
  MONTHLY = 'Per month',
  QUARTER = 'Per quarter',
  HALF_YEAR = 'Per half year',
  YEAR = 'Per year',
}

